import { Query } from '@promoboxx/graphql-gateway-types'

const EMBEDDED_SMART_SEARCH_STUBBED_DATA: {
  data?: Pick<Query, 'getShareSettingsAssetSearch'>
} = {
  data: {
    getShareSettingsAssetSearch: [
      {
        id: '1489361',
        campaign_id: '412549',
        name: 'Facebook Share 2',
        share_type: 'facebook',
        campaign: {
          id: '412549',
          name: 'Pet Care Quotes',
          creative_path: 'a9fb55b2c4780',
          brand: {
            id: '2192',
            name: 'Pet Care Industry Content',
            slug: 'pet-care-community',
            logo_url:
              'https://s3.amazonaws.com/promoboxx-api/brands/logos/2192/original/Screen_Shot_2022-11-18_at_4.46.55_PM.png?1668808028',
          },
        },
        digital_asset_associables: [
          {
            id: '1785546',
            file: {
              public_id: 'rccfezw1li2pbtc100vh',
            },
          },
        ],
      },
      {
        id: '1489363',
        campaign_id: '412549',
        name: 'Instagram Share 2',
        share_type: 'instagram',
        campaign: {
          id: '412549',
          name: 'Pet Care Quotes',
          creative_path: 'a9fb55b2c4780',
          brand: {
            id: '2192',
            name: 'Pet Care Industry Content',
            slug: 'pet-care-community',
            logo_url:
              'https://s3.amazonaws.com/promoboxx-api/brands/logos/2192/original/Screen_Shot_2022-11-18_at_4.46.55_PM.png?1668808028',
          },
        },
        digital_asset_associables: [
          {
            id: '1785546',
            file: {
              public_id: 'rccfezw1li2pbtc100vh',
            },
          },
          {
            id: '1785546',
            file: {
              public_id: 'rccfezw1li2pbtc100vh',
            },
          },
        ],
      },
      {
        id: '1489362',
        campaign_id: '412549',
        name: 'Twitter Share 2',
        share_type: 'twitter',
        campaign: {
          id: '412549',
          name: 'Pet Care Quotes',
          creative_path: 'a9fb55b2c4780',
          brand: {
            id: '2192',
            name: 'Pet Care Industry Content',
            slug: 'pet-care-community',
            logo_url:
              'https://s3.amazonaws.com/promoboxx-api/brands/logos/2192/original/Screen_Shot_2022-11-18_at_4.46.55_PM.png?1668808028',
          },
        },
        digital_asset_associables: [
          {
            id: '1785546',
            file: {
              public_id: 'rccfezw1li2pbtc100vh',
            },
          },
        ],
      },
      {
        id: 27964,
        share_type: 'facebook',
        campaign_id: 4356,
        name: 'Facebook Share 7',
        share_image_url:
          'https://res.cloudinary.com/promoboxxdev/image/upload/c_crop,h_274,w_523,x_1,y_0/nypddlfy8c7k0hsc4xm8.png',

        digital_asset_associables: [
          {
            id: 24020,
            file: {
              public_id: 'nypddlfy8c7k0hsc4xm8',
            },
          },
        ],
        campaign: {
          id: 4356,
          name: 'Random Campaign (DEV)',
          creative_path: 'f39d41f68d83c',
          brand: {
            id: '6',
            name: 'Ascension',
            slug: 'ascension',
            logo_url:
              'https://s3.amazonaws.com/promoboxx-api-dev/brands/logos/6/original/Stoneblade.png?1706891234',
          },
        },
      },
    ],
  },
} as unknown as any

export default EMBEDDED_SMART_SEARCH_STUBBED_DATA
